export function getFeed() {
    return {
        url: `/feed`,
    }
}